define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, DateUtils) {
    "use strict";
    var CalcRatesModel = /** @class */ (function () {
        function CalcRatesModel(data) {
            this.startDate = ko.observable(DateUtils.firstDayOfMonth());
            this.endDate = ko.observable(DateUtils.lastDayOfMonth());
            this.customerId = ko.observable(0);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CalcRatesModel.Mapping, self);
            }
        }
        CalcRatesModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CalcRatesModel(options.data);
            }
        };
        return CalcRatesModel;
    }());
    return CalcRatesModel;
});
//# sourceMappingURL=CalcRatesModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CalcRatesModel.js
// module id = 162
// module chunks = 2